import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_COMMON_INSTRUCTOR_GROUP, InstructorGroupPagination } from '../../models';
import { encodeURL } from '../../utils';
import { HttpService } from '../http';

@Injectable({
  providedIn: 'root',
})
export class InstructoGroupService {
  private readonly http = inject(HttpService);


  getAllInstructorGroup(params = {} as object): Observable<InstructorGroupPagination> {
    return this.http.get<InstructorGroupPagination>(encodeURL(API_COMMON_INSTRUCTOR_GROUP, params));
  }

  //   getPricingTier(params = {} as PricingTierLoadRemovePayload): Observable<PricingTierData> {
  //     return this.http.get<PricingTierData>(API_PRICING_LIST + params?.id + '/');
  //   }

  //   addPricingTier(params = {} as object): Observable<any> {
  //     return this.http.post<any>(API_PRICING_LIST, params);
  //   }

  //   updatePricingTier(params = {} as PricingTierCreateUpdatePayload): Observable<any> {
  //     return this.http.patch<any>(API_PRICING_LIST + params?.id + '/', params);
  //   }

  //   removePricingTier(params = {} as PricingTierLoadRemovePayload): Observable<any> {
  //     return this.http.delete<any>(API_PRICING_LIST + params?.id + '/');
  //   }
}
